import ContentCard from '@/components/app/cards/ContentCard';
import {
	isCollection,
	isNarrator,
	isProgramOrGuide,
	isRenderablePackItem,
	RenderablePackItem,
} from '@/components/app/cards/PacksList/types';
import PackClassLink from '@/components/app/ui/PackClassLink';

import { Subtitle, Title, TitleContainer, Wrapper } from './styles';
import { CardGridProps } from './types';

const CardGrid = ({ pack, searchQuery }: CardGridProps) => {
	// Keep each item's position in the server's original (pre-filter) array so
	// pack_item_index reflects the server's ranking, matching how mobile stamps
	// position before any client-side filtering — not this component's own
	// render-order index into the type-filtered subset.
	const supportedPacks = pack.items
		.map((packItem, serverIndex) => ({ packItem, serverIndex }))
		.filter((entry): entry is { packItem: RenderablePackItem; serverIndex: number } =>
			isRenderablePackItem(entry.packItem),
		);

	return (
		<>
			<TitleContainer>
				{pack.subtitle && <Subtitle>{pack.subtitle}</Subtitle>}
				{pack.title && !pack.subtitle && <Title>{pack.title}</Title>}
				{pack.has_more && <PackClassLink pack={pack} />}
			</TitleContainer>
			<Wrapper>
				{supportedPacks.map(({ packItem, serverIndex }) => (
					<ContentCard
						pack={pack}
						// `pack`-type items carry none of these ids, so they always fall through
						// to the positional fallback below.
						key={
							(isProgramOrGuide(packItem) ? (packItem.guide_id ?? packItem.program_id) : undefined) ??
							(isCollection(packItem) ? packItem.feed_id : undefined) ??
							(isNarrator(packItem) ? packItem.narrator_id : undefined) ??
							`${pack.id}-${serverIndex}`
						}
						card={packItem}
						searchQuery={{
							...searchQuery,
							pack_item_index: serverIndex,
						}}
					/>
				))}
			</Wrapper>
		</>
	);
};

export default CardGrid;
